import React, { useState } from "react";
import { Layout, styles } from "../../../layout";
import Figure from "../../components/figure";
import StyledButton from "../components/button";
import StyledInput from "../components/input";
import venmoImage from "./venmo.jpeg";

const ResumeAI: React.FC = () => {
  const [resumeLine, setResumeLine] = useState("");
  const [jobTarget, setJobTarget] = useState("");
  const [output, setOutput] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await fetch("/.netlify/functions/resumeai", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ resumeLine, jobTarget }),
      });

      const data = await res.json();
      setOutput(data.result);
    } catch (err) {
      console.error("API error", err);
      setOutput("Something went wrong. Try again.");
    }
  };

  return (
    <Layout title="Resume AI">
      <p style={styles.paragraph}>
        This is a simple AI resume builder powered by OpenAI's GPT-3.5.
      </p>
      <p style={styles.paragraph}>
        Write out one of your current resume bullet points in the first box.
        Then enter the field you’re applying to (e.g. Finance, Consulting,
        Tech). The AI will instantly improve your line — using action verbs,
        clearer structure, and quantified results when possible.
      </p>

      <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
        <div style={{ marginBottom: "15px" }}>
          <h3 style={{ display: "block", marginBottom: "5px" }}>Resume Line</h3>
          <textarea
            rows={3}
            value={resumeLine}
            onChange={(e) => setResumeLine(e.target.value)}
            placeholder="e.g. Helped organize events for the business club"
            style={{
              width: "100%",
              padding: "10px 12px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "16px",
              lineHeight: "1.4",
              fontFamily: "inherit",
              boxSizing: "border-box",
              resize: "vertical",
            }}
            required
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <h3 style={{ display: "block", marginBottom: "5px" }}>Job Target</h3>
          <StyledInput
            type="text"
            value={jobTarget}
            onChange={(e) => setJobTarget(e.target.value)}
            placeholder="e.g. Consulting, Tech, Finance"
            style={{ width: "100%", padding: "10px" }}
          />
        </div>

        <StyledButton type="submit" style={{ padding: "10px 20px" }}>
          Improve My Line
        </StyledButton>
      </form>

      {output && (
        <div
          style={{
            marginTop: "30px",
            padding: "10px",
            backgroundColor: "#f5f5f5",
          }}
        >
          <strong>AI Output:</strong>
          <p>{output}</p>
        </div>
      )}

      <div
        style={{ marginTop: "40px", display: "flex", justifyContent: "center" }}
      >
        <div style={{ width: "50%", minWidth: "200px" }}>
          <Figure
            imageSrc={venmoImage}
            altText="Support with Venmo"
            title="Keep ResumeAI Running"
            size="small"
            caption="Each $1 helps cover ~200–300 AI prompts. If ResumeAI helped you improve your resume, consider sending $1 to support server costs 💚"
          />
        </div>
      </div>
    </Layout>
  );
};

export default ResumeAI;
